import { createContext, useContext } from "react";

import type { AccordionContextValue } from "./Accordion.types";

export const AccordionContext = createContext<AccordionContextValue | null>(
  null,
);

export function useAccordionContext(): AccordionContextValue | null {
  return useContext(AccordionContext);
}
